import React, { Component } from "react";
import {message, Modal, Upload} from "antd";
import {FilePdfOutlined, UploadOutlined} from '@ant-design/icons';
import {isEmpty} from "lodash";
import PreviewLetter from "./PreviewLetter";

class ActivateService extends Component {
  state = {
    serviceContract: {},
    loading: false,
    showPreview: false
  }

  // toggle pdf preview
  togglePreview = (value) => {
    if (this.state.showPreview !== value) {
      this.setState({showPreview: value})
    }
  }

  // on Upload doc
  onUpload = (e) => {
    let { serviceContract } = this.state;
    const file = e?.file;
    if (file?.size > (5 * 1048576)) {
      message.error('File size should be less than 5MB');
    } else {
      file && this.getBase64String(file, (result) => {
        serviceContract = {...e.file, name: file?.name, imageUrl: result};
        this.setState({serviceContract})
      })
    }
  }

  // get base 64 string
  getBase64String = (file = {}, cb) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onloadend = function () {
      cb(reader.result);
    }
  };

  render() {
    const { visible, onCancel, onActiveService } = this.props;
    const {serviceContract, showPreview} = this.state;

    let file_name = '';
    if (serviceContract?.imageUrl?.includes('https:')) {
      let url = serviceContract?.imageUrl?.split('?') || [];
      file_name = url?.[0]?.split('/')?.[url?.[0]?.split('/')?.length - 1]
    }

    return (
      <Modal
        title="Activate Service"
        visible={visible}
        closable={false}
        footer={[
          <button key="cancel" className="btn btn-bdr" onClick={() => onCancel()}>Cancel</button>,
          <button key="save" className="btn btn-warning" onClick={() => onActiveService(serviceContract)}>Activate Service</button>
        ]}
      >
        <p>
          {"This proposal will be removed and you will be able to access this service under the customer's active profile."}
        </p>
        <p>
          Any Pet Waste Stations that may be required will be added to the kanban ready for scheduling and installation.
        </p>
        <b className="d-block mb-10">Contract:</b>
        {
          !isEmpty(serviceContract) ?
            <div className={'cover-letters flex-1'} style={{marginLeft: "0"}}>
              <div className={'flex cvrow'} style={{"maxWidth": "100%", marginRight: "0"}}>
                <figure>
                  <FilePdfOutlined className="fileprev" style={{height: 55, width: 50}}/>
                </figure>
                <div className="filedetail">
                  <h4>{file_name || serviceContract?.name}</h4>
                  <span className="action-link">
                    <a href="/#" onClick={(e) => {e.preventDefault(); this.togglePreview(true)}}><u>{'Preview'}</u></a>
                  </span>
                </div>
              </div>
            </div> : '' }
        <Upload
          name={'file'}
          beforeUpload={() => false}
          accept=".pdf,application/pdf"
          showUploadList={false}
          className="avatar-uploader"
          style={{marginLeft: "10px"}}
          onChange={this.onUpload}>
          <p className="ant-upload-drag-icon">
            <UploadOutlined />
          </p>
          <p>Drag and drop the service contract or <b>click here</b> to upload</p>
        </Upload>
        {showPreview && <PreviewLetter
          file={serviceContract?.imageUrl}
          visible={showPreview}
          handleCancel={() => this.togglePreview(false)} />}
      </Modal>
    );
  }
}

export default ActivateService;
